import { Formik } from 'formik';
import * as yup from 'yup';
import {
  Box,
  Button,
  Flex,
  Label,
  Input,
  FormMessage,
  theme,
} from '@xometry/xometry_loft';
import {
  firstName,
  companyName,
  lastName,
  requiredMessage,
  email,
  phone,
} from '../../../utils/validations';

const schema = yup.object().shape({
  first_name: firstName.required(requiredMessage),
  last_name: lastName.required(requiredMessage),
  company_name: companyName.when('requireCompany', {
    is: true,
    then: yup.string().required(requiredMessage),
    otherwise: yup.string().nullable(),
  }),
  email_address: email.required(requiredMessage),
  phone_number: phone,
});

const UserEditForm = (props) => {
  const { initialValues, onCancel, onSave } = props;

  return (
    <Box>
      <Formik
        initialValues={initialValues}
        onSubmit={onSave}
        validationSchema={schema}
      >
        {({
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
          handleSubmit,
          isSubmitting,
        }) => {
          const invalidFirstName = Boolean(
            errors.first_name && touched.first_name
          );

          const invalidLastName = Boolean(
            errors.last_name && touched.last_name
          );

          const invalidCompanyName = Boolean(
            errors.company_name && touched.company_name
          );

          const invalidEmailAddress = Boolean(
            errors.email_address && touched.email_address
          );

          const invalidPhoneNumber = Boolean(
            errors.phone_number && touched.phone_number
          );

          return (
            <form onSubmit={handleSubmit}>
              <Box marginBottom={theme.space[6]}>
                <Box marginBottom={theme.space[3]}>
                  <Label htmlFor="first_name">First Name</Label>
                  <Input
                    className="pii-encrypt"
                    type="text"
                    id="first_name"
                    name="first_name"
                    width="100%"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.first_name}
                    invalid={invalidFirstName}
                  />
                  {errors.first_name && touched.first_name && (
                    <FormMessage invalid={invalidFirstName}>
                      {errors.first_name}
                    </FormMessage>
                  )}
                </Box>
                <Box marginBottom={theme.space[3]}>
                  <Label htmlFor="last_name">Last Name</Label>
                  <Input
                    className="pii-encrypt"
                    type="text"
                    id="last_name"
                    name="last_name"
                    width="100%"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.last_name}
                    invalid={invalidLastName}
                  />
                  {errors.last_name && touched.last_name && (
                    <FormMessage invalid={invalidLastName}>
                      {errors.last_name}
                    </FormMessage>
                  )}
                </Box>
                <Box marginBottom={theme.space[3]}>
                  <Label htmlFor="company_name">Company Name</Label>
                  <Input
                    type="text"
                    id="company_name"
                    name="company_name"
                    width="100%"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.company_name}
                    invalid={invalidCompanyName}
                  />
                  {errors.company_name && touched.company_name && (
                    <FormMessage invalid={invalidCompanyName}>
                      {errors.company_name}
                    </FormMessage>
                  )}
                </Box>
                <Box marginBottom={theme.space[3]}>
                  <Label htmlFor="phone_number">Phone Number</Label>
                  <Input
                    type="text"
                    className="pii-encrpyt"
                    id="phone_number"
                    name="phone_number"
                    width="100%"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.phone_number}
                    invalid={invalidPhoneNumber}
                  />
                  {errors.phone_number && touched.phone_number && (
                    <FormMessage invalid={invalidPhoneNumber}>
                      {errors.phone_number}
                    </FormMessage>
                  )}
                </Box>
                <Box marginBottom={theme.space[3]}>
                  <Label htmlFor="email_address">Email Address</Label>
                  <Input
                    className="pii-encrypt"
                    type="text"
                    id="email_address"
                    name="email_address"
                    width="100%"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.email_address}
                    invalid={invalidEmailAddress}
                    disabled
                  />
                  {errors.email_address && touched.email_address && (
                    <FormMessage invalid={invalidEmailAddress}>
                      {errors.email_address}
                    </FormMessage>
                  )}
                </Box>
              </Box>
              <Flex justifyContent="flex-end">
                <Button
                  type="button"
                  kind={theme.kind.primaryOutline}
                  onClick={onCancel}
                  marginRight={theme.space[2]}
                >
                  Cancel
                </Button>
                <Button kind="primary" type="submit" disabled={isSubmitting}>
                  Update
                </Button>
              </Flex>
            </form>
          );
        }}
      </Formik>
    </Box>
  );
};

export default UserEditForm;
